module.exports = __webpack_public_path__ + "img/right_bg.18328de.png";